export const part_form_strings = {
  create_title: "Create New Part",
  update_title: "Edit Part",

  // Field labels
  manufacturerLabel: "Manufacturer*",
  frameLabel: "Frame*",
  partNumberLabel: "Part Number*",
  turbineModelLabel: "Turbine Model*",
  quantityLabel: "Quantity*",
  descriptionLabel: "Description",
  serialNumberLabel: "Serial Number",
  upgradeDesignationsLabel: "Upgrades",
  castingNumberLabel: "Casting Number",
  matchedHardwareLabel: "Matched Hardware",
  totalFactoredFiredHoursLabel: "Total Factored Fired Hours",
  totalFactoredFiredStartsLabel: "Total Factored Fired Starts",
  emergencyTripsLabel: "Emergency Trips",
  timesRefurbishedLabel: "Times Refurbished",
  priceUnitAmountLabel: "Price (USD)",
  statusLabel: "Status",
  organizationLabel: "Organization",
  conditionLabel: "Condition*",
  partTypeLabel: "Part Type",
  categoryLabel: "Category",
  dateListedLabel: "Date Listed",
  dateSoldLabel: "Date Sold",
  tagsLabel: "Tags",
  addressLabel: "Address",
  addressFormattedLabel: "Formatted Address",
  addressStreetLabel: "Street Address",
  addressLocalityLabel: "City/Town",
  addressRegionLabel: "State/Region",
  addressCountryLabel: "Country",
  addressPostalCodeLabel: "Postal Code",
  thumbnailUrlLabel: "Thumbnail",

  // Field placeholders
  manufacturerPlaceholder: "Enter manufacturer name",
  framePlaceholder: "Enter frame identifier",
  partNumberPlaceholder: "Enter part number",
  turbineModelPlaceholder: "Enter turbine model",
  quantityPlaceholder: "Enter quantity",
  descriptionPlaceholder: "Enter description",
  serialNumberPlaceholder: "Enter serial number",
  upgradeDesignationsPlaceholder: "Enter Upgrades",
  castingNumberPlaceholder: "Enter casting number",
  totalFactoredFiredHoursPlaceholder: "Enter total factored fired hours",
  totalFactoredFiredStartsPlaceholder: "Enter total factored fired starts",
  emergencyTripsPlaceholder: "Enter emergency trips count",
  timesRefurbishedPlaceholder: "Enter number of times refurbished",
  priceUnitAmountPlaceholder: "0.00",
  thumbnailUrlPlaceholder: "Select a photo file for thumbnail",
  noThumbnailUrlPlaceholder:
    "No photos available. Upload photo files, then choose a thumbnail.",

  // Validation messages
  manufacturerRequired: "Manufacturer is required",
  manufacturerTooLong: "Manufacturer must be 100 characters or less",
  frameRequired: "Frame is required",
  frameTooLong: "Frame must be 50 characters or less",
  partNumberRequired: "Part number is required",
  partNumberTooLong: "Part number must be 50 characters or less",
  turbineModelRequired: "Turbine model is required",
  turbineModelTooLong: "Turbine model must be 100 characters or less",
  quantityRequired: "Quantity is required",
  quantityTooSmall: "Quantity must be at least 1",
  quantityTooLarge: "Quantity must be 999,999,999 or less",
  descriptionTooLong: "Description must be 500 characters or less",
  lastShopVisitTooLong: "Last shop visit must be 1000 characters or less",
  serialNumberTooLong: "Serial number must be 100 characters or less",
  lastSellingShopNameTooLong:
    "Last selling shop name must be 200 characters or less",
  upgradeDesignationsTooLong: "Upgrades must be 500 characters or less",
  castingNumberTooSmall: "Casting number must be at least 1",
  castingNumberTooLarge: "Casting number must be 999,999,999 or less",
  lastSaleDateInvalid: "Please enter a valid date and time",

  // File uploads
  fileUploadsTitle: "File Uploads",
  pedigreeFilesTitle: "Pedigree Files",
  shopReleaseFilesTitle: "Shop Release Files",
  flowTestFilesTitle: "Flow Test Report Files",
  dimensionalInspectionFilesTitle: "Dimensional Inspection Files",
  ndeReportFilesTitle: "NDE Report Files",
  photoFilesTitle: "Photo Files",

  // Tab labels
  detailsTab: "Details",
  filesTab: "Files",

  // Actions
  saveChanges: "Save Changes",
  addPart: "Add Part",
  cancel: "Cancel",
} as const;
